import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function TeamPage() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-268">
      <Navigation data-id="element-269" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-270">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz" data-id="element-271">Team</h1>
      </main>
      <Footer data-id="element-272" />
    </div>;
}